// Select, detect trigger placement and pass to callback
export var getPopupContainerSelectHelper = function (node, callback) {
    var _a, _b;
    var nodeHTML = node;
    var child = (_b = (_a = nodeHTML.children) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : undefined;
    if (child && child.getAttribute('trigger-placement') && callback) {
        callback(child.getAttribute('trigger-placement'));
    }
    return document.body;
    // return node;
};
//# sourceMappingURL=observer.js.map